import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "mid",
  "use": "mid-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"mid\">\n  <path d=\"M12.4545 6.93939L15 4.39394L15 15H4.39393L6.93938 12.4545H12.4545L12.4545 6.93939Z\" fill=\"#727272\" />\n  <path d=\"M3.54546 9.06061L1 11.6061L1.00001 1L11.6061 1L9.06061 3.54545H3.54546V9.06061Z\" fill=\"#727272\" />\n  <path d=\"M1 15V12.4545L12.4545 1H15V3.54545L3.54545 15H1Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol